import { isEmpty } from './index'

export const validateRequired = value => (value && value.length ? true : 'Este campo es requerido')

export const validateEmail = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'Debe introducir un correo electrónico válido'
}

export const validatePassword = value => {
  if (isEmpty(value)) {
    return true
  }

  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  // eslint-disable-next-line
  var result = regExp.test(String(value)) || 'El campo debe contener al menos un caracter especial, una mayúscula, una minúscula y un dígito con un mínimo de 8 caracteres'

  return result
}

export const required = value => {
  if (!value || value === '') {
    return 'Este valor es obligatorio'
  }

  return true
}

export const fixedlen = (v, length) => {
  if (v && length && v.length !== length) {
    return `Introduzca exactamente ${length} caracteres`
  }

  return true
}

export const text = v => {
  if (/^[a-z A-ZáéíóúàèìòùÀÈÌÒÙÁÉÍÓÚñÑüÜ\s0-9]+$/.test(v)) {
    return 'Sólo se admiten caracteres alfanuméricos y no caracteres especiales'
  }

  return true
}

export const string = v => {
  if (/^[a-z A-ZáéíóúàèìòùÀÈÌÒÙÁÉÍÓÚñÑüÜ\s]+$/.test(v)) {
    return 'Sólo se admiten letras Aa-Zz'
  }

  return true
}

export const decimal = v => {
  if (!/^(\d+|\d+\.\d{2})$/.test(v)) {
    return 'Es necesario introducir un valor numérico con 2 decimales'
  }

  return true
}

export const number = v => {
  if (v && !/^\d+$/.test(v)) {
    return 'Sólo se admiten números'
  }

  return true
}

export const moreThan = (v, x) => {
  if (v <= x) {
    return `Es necesario introducir un valor mayor a ${x}`
  }

  return true
}

export const email = v => {
  if (/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(v)) {
    return 'Sólo se admite un correo electrónico de la forma usuario@servidor.com'
  }

  return true
}

export const password = v => {
  if (/((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/.test(v)) {
    return 'La contraseña debe contener números, letras y al menos 8 caracteres, hasta un máximo de 20'
  }

  return true
}
